module.exports = __webpack_public_path__ + "img/banner-9.72553850.jpg";